import {Component, Input} from '@angular/core';
import {StateService} from "@uirouter/core";
import * as _ from 'lodash';

import {
    MenuService,
    ParametersService,
    SubtitlesService, ViewsService,
    ZonesService
} from "../../core";
import {ZoneTileType23_24, ZoneTileViewData} from "../../models";


@Component({
    selector: 'built-in-valve',
    templateUrl: './built-in-valve.component.html',
    styleUrls: ['./built-in-valve.component.scss']
})
export class BuiltInValveComponent {
    @Input() tile: ZoneTileType23_24;

    constructor(
        private menu: MenuService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
        public zones: ZonesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    setTemplate(tile: ZoneTileType23_24): void {
        if (window.innerWidth > 696) {
            this.goToZonesMenu(tile);
            return;
        }


        let tileName = '';

        if (tile.params.txtId && tile.params.txtId !== -1) {
            tileName = this.subtitles.setSubtitle(tile.params.txtId);
        }

        const zonesValue: ZoneTileViewData = {
            description: {
                name: tileName || this.subtitles.setSubtitle(2588),
                styleIcon: 'valve'
            },
            tile: tile
        };
        this.zones.selectedZone = _.cloneDeep(zonesValue);
        this.$state.go('valve_select', {
            selectedModuleHash: this.parameters.selectedModuleHash
        });
    }

    private goToZonesMenu(tile: ZoneTileType23_24) {
        if (!this.tile.submenuElementId) {
            this.setSubmenuElementId();
        }
        this.zones.goToMenu(tile, this.tile.submenuElementId);
    }

    private setSubmenuElementId() {
        this.menu.getElementMenu(this.tile.menuId); // menu element for tile
        this.menu.getMenuChildElement(this.menu.elementMenu) // set menu.submenu
        if (this.menu.submenu[0]) {
            this.tile.submenuElementId = this.menu.submenu[0].id;
        }
    }
}
